export const GLOBAL_CONSTANTS = {
    ESCAPE_KEY: 27,
    ENTER_KEY: 13,
    F1_KEY: 112,
    YES: 'Y',
    NO: 'N',

    INTEGRATION_SOURCE_SWIFT_ENTERPRISE: 'SE',
    SWIFTENTERPRISE: 'SE',
    UNORDERED_LIST_ITEM: 'unordered-list-item',
    ORDERED_LIST_ITEM : 'ordered-list-item',

    ISSUE_LISTING: 'ISSUE_LISTING',
    ADD_ISSUE_COLLECTOR: 'ADD_ISSUE_COLLECTOR',
    EDIT_ISSUE_COLLECTOR: 'EDIT_ISSUE_COLLECTOR',
    ISSUE_COLLECTOR_CONGRATS: 'ISSUE_COLLECTOR_CONGRATS',
    ENABLED: 'enabled',
    DIENABLED: 'disabled',
    TEXTBOX:"Text",
    COMBO:"Combo",
    MULTISELECT: "MultiSelect",
    MULTISELECTLIST: "MultiSelectListBox",
    CHECKBOX:"CheckBox",
    TEXTAREA:"TextArea",
    REACH_TEXTBOX:"RText",
    RADIOBUTTON:"RadioButton",
    FIELD_DATA_TYPE_STRING : "string",
    FIELD_DATA_TYPE_NUMBER : "number",
    CRYPTO_JS_KEY: 'f8b7b47e03530t06',
    CRYPTO_IV: '6d868e3bedd69584',
    ADD_CUSTOM_INLINE_STYLE: 'ADD_CUSTOM_INLINE_STYLE',
    HIDDEN_FEILD_PREFIX: 'hidden_'
};

export const APP_URL_CONSTANTS = {
    LOGIN: 'login',
    GET_CONFIG: 'core/app/v1/getConfig',
    EXECUTE_QUERY_DATA: 'core/querydata/v1/execute',
    ENCRYPT_QUERY_DATA: 'core/querydata/v1/encrypt',
    CREATE_ISSUE_COLLECTOR_URL: 'core/issue/v1/create',
    DELETE_ISSUE_COLLECTOR_URL: 'core/issue/v1/delete',
    CHANGE_ISSUE_COLLECTOR__STATUS_URL: 'core/issue/v1/changestatus',
    READ_ISSUE_COLLECTOR_LIST: 'core/issue/v1/readAll',
    RESET_ISSUE_CONFIG_URL: 'core/issue/v1/getCollectorById',
    GET_ISSUE_COLLECTOR_BY_ID:"core/issue/v1/getCollectorById",
    GET_CARD_TYPE_SETTINGS: 'core/cardtype-operations/v1/cardtype',
    SAVE_CARD_TYPE_SETTINGS: 'core/cardtype-operations/v1/cardtypes',
    GET_CARD_CUSTOM_FIELDS_URL: 'core/issue/v1/getCustomFields',
    UPDATE_COLLECTOR_CUSTOM_FIELDS: 'core/issue/v1/updateCustomFields/',
    SAVE_IMAGE_URL: 'core/media/v1/create',
    GET_ALL_WORK_REQUESTS: 'core/outlookPlugin/v1/getAccesibleExternalWorkRequest',
    SYNC_CARD_TYPES: 'core/app/v1/syncCardTypes',
    ADD_NEW_ISSUE: "core/issue/v1/addNewIssue",
    VERIFY_GOOGLE_RECAPTCHA : "core/app/v1/verifyRecaptcha",
    GET_QUERY_META_DATA: 'core/app/v1/getQueryDataConfig',
    GET_SOURCE_PROPERTIES_URL: 'core/app/v1/getSourceProperties',
    GET_ENTERPRISE_DATA_FROM_IC_ID_URL: 'core/enterprise/readFromICID'
}